import { render } from "./TablaProfesionalesAsignados.vue?vue&type=template&id=4a62ca3c&ts=true"
import script from "./TablaProfesionalesAsignados.vue?vue&type=script&lang=ts"
export * from "./TablaProfesionalesAsignados.vue?vue&type=script&lang=ts"

import "./TablaProfesionalesAsignados.vue?vue&type=style&index=0&id=4a62ca3c&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__